import { Address } from 'src/app/shared/models/address.model';
import { Room } from 'src/app/shared/models/room.model';

const addressToAddressAccordance = {
  addressLine1: 'address1',
  addressLine2: 'address2',
  addressLine3: 'address3',
  cityName: 'city',
  countyName: 'county',
  zipCode: 'postcode'
};

export const mapAddressResponseToAddress = (addressObject): Address => {
  const response = Object.assign({}, addressObject);
  Object.keys(addressToAddressAccordance).forEach(key => {
    const descriptor = Object.getOwnPropertyDescriptor(response, key);
    if (!descriptor) return;
    Object.defineProperty(response, addressToAddressAccordance[key], descriptor);
    delete response[key];
  });
  return response;
};

export const mapRoomsAdditionalParams = (rooms: Array<Room>): Array<Room> => {
  let minPriceCenterNumber: number;
  let maxPriceCenterNumber: number;
  const roomsWithPrice = rooms.filter(room => room?.price?.value !== null && room?.price?.value !== undefined);

  if (roomsWithPrice.length > 0) {
    const sortedRooms = [...roomsWithPrice].sort((room1, room2) => room1.price.value > room2.price.value ? 1 : -1);
    minPriceCenterNumber = sortedRooms[0].centreNumber;
    maxPriceCenterNumber = sortedRooms.at(-1).centreNumber;
  }
  return rooms.map(room =>
    Object.assign({}, room, {
      isBestValue: room.centreNumber === minPriceCenterNumber,
      isPrestige: room.centreNumber === maxPriceCenterNumber
    })
  );
};

export const mapRooms = (
  unhandledRooms: Room[],
): Room[] => {
  return unhandledRooms.map((room) =>
    Object.assign({}, room, {
      address: mapAddressResponseToAddress(room.address),
    })
  );

};
